import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import ExpenseModal from './ExpenseModal';
import { useParams, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import { useAuth } from '../../../context/AuthContext';
import withPermission from '../../../utils/withPermission';
import Swal from 'sweetalert2';
import { FaFilter, FaFileAlt, FaEye } from "react-icons/fa";
import { InputGroup, Form, Dropdown } from 'react-bootstrap';
import { FiSearch } from 'react-icons/fi';
import withReactContent from "sweetalert2-react-content";
import "react-datepicker/dist/react-datepicker.css";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import Select from 'react-select';
const AllExpenseList = () => {
    const [expenses, setExpenses] = useState([]);
    const [instances, setInstances] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedExpenseId, setSelectedExpenseId] = useState(null);
    const [selectedExpenseData, setSelectedExpenseData] = useState(null);
    const [errors, setErrors] = useState({});
    const didFetchRef = useRef(false);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const { id } = useParams();
    const [industries, setIndustries] = useState([]);
    const { roles, permissions } = useAuth();
    const WithDeletePermission = withPermission(({ children }) => children, ['expense-delete']);
    const WithEditPermission = withPermission(({ children }) => children, ['expense-edit']);
    const WithCreatePermission = withPermission(({ children }) => children, ['expense-create']);
    const [searchQuery, setSearchQuery] = useState('');
    const debounceTimeoutRef = useRef(null);
    const [statusFilter, setStatusFilter] = useState('all');
    const [expenseTypes, setExpenseTypes] = useState([]);
    const [users, setUsers] = useState([]);
    const [projectFilter, setProjectFilter] = useState('');
    const [expenseTypeFilter, setExpenseTypeFilter] = useState('');
    const [userFilter, setUserFilter] = useState('');
    const [typeFilter, setTypeFilter] = useState('');
    const [filterDropdown, setFilterDropdown] = useState(null); // Controls which filter dropdown is open
    const [showDropdown, setShowDropdown] = useState(false);
    const [dateFilterDropdown, setDateFilterDropdown] = useState(false);
    const [dateRange, setDateRange] = useState({ from: '', to: '' });
    const [showSummary, setShowSummary] = useState(false);

    const [showSummaryBox, setShowSummaryBox] = useState(true);
    const [attachmentFilter, setAttachmentFilter] = useState('all'); // 'all', 'with', 'without'
    const [startDateFilter, setStartDateFilter] = useState('');
    const [endDateFilter, setEndDateFilter] = useState('');
    const [summaryFilter, setSummaryFilter] = useState('all'); // 'all', 'taxable', 'non-taxable'
    const [filteredExpenses, setFilteredExpenses] = useState([]);
    const [hasInitialLoad, setHasInitialLoad] = useState(false);
    const [sourceFilter, setSourceFilter] = useState([]);
    const [paymentStatusFilter, setPaymentStatusFilter] = useState('');
    const [vendors, setVendors] = useState([]);
    const [vendorFilter, setVendorFilter] = useState('');
    const [selectedYear, setSelectedYear] = useState(null);
    const [selectedEndYear, setSelectedEndYear] = useState(null);
    const [dateRangeFilter, setDateRangeFilter] = useState('yearly');

    const handleDateRangeChange = (value) => {
        setDateRangeFilter(value);
        const now = dayjs();
        if (value === 'yearly') {
            setSelectedYear(null);
            setSelectedEndYear(null);
            setStartDateFilter('');
            setEndDateFilter('');
        }
    };

    const handleSourceFilterChange = (source) => {
        if (sourceFilter.includes(source)) {
            setSourceFilter(prev => prev.filter(item => item !== source));
        } else {
            setSourceFilter(prev => [...prev, source]);
        }
    };

    useEffect(() => {
        if (!didFetchRef.current) {

            // fetchIndustries();
            didFetchRef.current = true;
        }
    }, [currentPage]);
    const [accountStatus, setAccountStatus] = useState('all');
    // useEffect(() => {
    //     if (debounceTimeoutRef.current) {
    //         clearTimeout(debounceTimeoutRef.current);
    //     }

    //     debounceTimeoutRef.current = setTimeout(() => {
    //         fetchExpenses({
    //             page: 1,
    //             search: searchQuery,
    //             project: projectFilter,  // ✅ Always send filters if selected
    //             expenseType: expenseTypeFilter,
    //             user: userFilter,
    //             type: typeFilter,
    //         });
    //     }, searchQuery ? 1500 : 0);

    //     return () => clearTimeout(debounceTimeoutRef.current);
    // }, [searchQuery, projectFilter, expenseTypeFilter, userFilter, typeFilter]);
    // useEffect(() => {
    //     if (debounceTimeoutRef.current) {
    //         clearTimeout(debounceTimeoutRef.current);
    //     }

    //     debounceTimeoutRef.current = setTimeout(() => {
    //         fetchExpenses({
    //             page: 1,
    //             search: searchQuery,
    //             project: projectFilter,
    //             expenseType: expenseTypeFilter,
    //             user: userFilter,
    //             type: typeFilter,
    //             startDate: startDateFilter,
    //             endDate: endDateFilter,
    //             attachment: attachmentFilter !== 'all' ? attachmentFilter : '',
    //             taxType: summaryFilter
    //         });
    //     }, searchQuery ? 1500 : 0);

    //     return () => clearTimeout(debounceTimeoutRef.current);
    // }, [
    //     searchQuery,
    //     projectFilter,
    //     expenseTypeFilter,
    //     userFilter,
    //     typeFilter,
    //     startDateFilter,
    //     endDateFilter,
    //     attachmentFilter,
    //     summaryFilter
    // ]);


    const calculateSummary = (expenseList) => {
        if (!expenseList || expenseList.length === 0) {
            setSummaryData({
                taxable: { count: 0, totalAmount: 0, totalTax: 0, totalAfterTax: 0 },
                nonTaxable: { count: 0, totalAmount: 0, totalTax: 0, totalAfterTax: 0 },
                overall: { count: 0, totalAmount: 0, totalTax: 0, totalAfterTax: 0 }
            });
            return;
        }

        let taxable = { count: 0, totalAmount: 0, totalTax: 0, totalAfterTax: 0 };
        let nonTaxable = { count: 0, totalAmount: 0, totalTax: 0, totalAfterTax: 0 };
        let overall = { count: 0, totalAmount: 0, totalTax: 0, totalAfterTax: 0 };

        expenseList.forEach(expense => {
            const amount = parseFloat(expense.amount) || 0;
            const totalAmount = parseFloat(expense.total_amount) || amount;
            let taxAmount = 0;

            if (expense.tax_type === 'taxable') {
                // Use saved vat_amount if available, otherwise calculate using tax% (default 5%)
                const amountWithoutTax = parseFloat(expense.amount_without_tax) || amount;
                const taxRate = parseFloat(expense.tax || 5) / 100;
                taxAmount = (expense.vat_amount !== null && expense.vat_amount !== undefined)
                    ? parseFloat(expense.vat_amount)
                    : (amountWithoutTax * taxRate);

                taxable.count++;
                taxable.totalAmount += amountWithoutTax;
                taxable.totalTax += taxAmount;
                taxable.totalAfterTax += totalAmount;
            } else {
                // For non-taxable items, no VAT
                nonTaxable.count++;
                nonTaxable.totalAmount += amount;
                nonTaxable.totalTax += 0;
                nonTaxable.totalAfterTax += amount;
            }

            overall.count++;
            overall.totalAmount += expense.tax_type === 'taxable' ? (parseFloat(expense.amount_without_tax) || amount) : amount;
            overall.totalTax += taxAmount;
            overall.totalAfterTax += totalAmount;
        });

        setSummaryData({
            taxable,
            nonTaxable,
            overall
        });
    };




    // Remove applyLocalFilters function - we don't need it anymore

    // Update clearAllFilters function
    const applyFilters = () => {
        setCurrentPage(1);

        fetchExpenses({
            page: 1,
            search: searchQuery,
            project: projectFilter,
            expenseType: expenseTypeFilter,
            user: userFilter,
            vendor: vendorFilter,
            type: typeFilter,
            startDate: startDateFilter,
            endDate: endDateFilter,
            attachment: attachmentFilter !== 'all' ? attachmentFilter : '',
            taxType: summaryFilter,
            source: sourceFilter,
            paymentStatus: statusFilter
        });
        setHasInitialLoad(true); // Mark that data has been loaded at least once
    };

    const clearAllFilters = () => {
        setStartDateFilter('');
        setEndDateFilter('');
        setAttachmentFilter('all');
        setSummaryFilter('all');
        setStatusFilter('all');
        setSearchQuery('');
        setProjectFilter('');
        setExpenseTypeFilter('');
        setUserFilter('');
        setVendorFilter('');
        setTypeFilter('');
        setSourceFilter([]);
        setCurrentPage(1);

        // Clear the data when clearing filters
        setExpenses([]);
        setSummaryData({
            total_amount: 0,
            total_vat: 0,
            grand_total: 0,
            total_count: 0,
            taxable_count: 0,
            non_taxable_count: 0
        });
        setHasInitialLoad(false);
    };
    // Update handlePageClick to include all filters
    const handlePageClick = ({ selected }) => {
        const newPage = selected + 1;
        fetchExpenses({
            page: newPage,
            search: searchQuery,
            project: projectFilter,
            expenseType: expenseTypeFilter,
            user: userFilter,
            vendor: vendorFilter,
            type: typeFilter,
            startDate: startDateFilter,
            endDate: endDateFilter,
            attachment: attachmentFilter !== 'all' ? attachmentFilter : '',
            taxType: summaryFilter,
            source: sourceFilter,
            paymentStatus: statusFilter
        });
    };

    // NEW FUNCTION: Format currency
    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount || 0);
    };
    const MySwal = withReactContent(Swal);

    const showToast = (message, type = "error") => {
        MySwal.fire({
            toast: true,
            position: "top-end",
            icon: type,
            title: message,
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
        });
    };

    const showToast1 = (message, type = "show") => {
        MySwal.fire({
            toast: true,
            position: "top-end",
            icon: type,
            title: message,
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
        });
    };


    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const [summaryData, setSummaryData] = useState({
        total_amount: 0,
        total_vat: 0,
        total_adjustment: 0,
        total_wps_charge: 0,
        total_wps_vat: 0,
        total_paid: 0,
        total_unpaid: 0,
        total_balance: 0,
        grand_total: 0,
        total_count: 0,
        taxable_count: 0,
        non_taxable_count: 0
    });

    const isSalarySearch = (Array.isArray(sourceFilter) ? (sourceFilter.includes('salary') || sourceFilter.length === 0) : (sourceFilter === 'salary' || !sourceFilter || sourceFilter === 'all')) || searchQuery?.toLowerCase().includes('employee salary') ||
        expenseTypes.find(t => t.id?.toString() === expenseTypeFilter?.toString())?.name?.toLowerCase().includes('employee salary');

    const isStandardSearch = (Array.isArray(sourceFilter) ? (sourceFilter.includes('direct') || sourceFilter.includes('pettycash')) : (sourceFilter === 'direct' || sourceFilter === 'pettycash')) || (sourceFilter.length === 0);


    const fetchExpenses = async ({
        page = 1,
        search = '',
        project = '',
        expenseType = '',
        user = '',
        vendor = '',
        type = '',
        startDate = '',
        endDate = '',
        attachment = '',
        taxType = '',
        source = 'all',
        paymentStatus = 'all'
    } = {}) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            let params = new URLSearchParams();
            params.append('page', page);

            // Apply ALL filters to the API call
            if (search) params.append('search', search);
            if (project === 'no-project') {
                params.append('no_project', 'true');
            } else if (project) {
                params.append('project_id', project);
            }
            if (expenseType) params.append('expense_type_id', expenseType);
            if (user) params.append('user_id', user);
            if (vendor) params.append('vendor_id', vendor);
            if (startDate) params.append('from_date', startDate);
            if (endDate) params.append('to_date', endDate);
            if (type) params.append('tax_type', type);
            if (attachment === 'without') {
                params.append('attachment_null', 'true');
            } else if (attachment === 'with') {
                params.append('attachment_not_null', 'true');
            }
            if (taxType && taxType !== 'all') {
                params.append('tax_type', taxType);
            }
            if (Array.isArray(source) && source.length > 0) {
                params.append('source', source.join(','));
            } else if (source && source !== 'all' && !Array.isArray(source)) {
                params.append('source', source);
            }
            if (paymentStatus && paymentStatus !== 'all') {
                params.append('payment_status', paymentStatus);
            }

            const response = await axios.get(`${backendUrl}/api/expense?${params.toString()}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            // Extract data and summary from response
            const expenseData = response.data.data?.data || [];
            const summary = response.data.summary || {
                total_amount: 0,
                total_vat: 0,
                grand_total: 0,
                total_count: 0,
                taxable_count: 0,
                non_taxable_count: 0
            };

            const totalPages = response.data.data?.last_page || 1;
            const currentPage = response.data.data?.current_page || 1;

            setExpenses(expenseData);

            // If it's a salary search, ensure we include WPS totals from the backend
            if (isSalarySearch) {
                summary.total_wps_vat = summary.total_wps_vat || 0;
                summary.total_wps_charge = summary.total_wps_charge || 0;

                // If it's ONLY salary search, we can use total_wps_vat as primary VAT
                // but if it's mixed, we should keep them separate.
                if (sourceFilter.length === 1 && sourceFilter.includes('salary')) {
                    summary.total_vat = summary.total_wps_vat;
                }
            }

            setSummaryData(summary);
            setPageCount(totalPages);
            setCurrentPage(currentPage);

            // Diagnostic logging for debugging discrepancies
            const debugData = expenseData.map(e => {
                const id = e.id || e.expense_id || e.pe_id || e.ID;
                const narration = e.narration || e.description || e.remarks || "No Narration";
                const amount = e.total_amount || e.amount || e.total || e.Amount;
                
                return { 
                    id, 
                    narration, 
                    amount: Number(amount) || 0,
                    payment_status: e.payment_status 
                };
            });
        } catch (error) {
            console.error('Error fetching expenses:', error);
        }
    };


    // const fetchExpenses = async ({ page = 1, search = '', project = '', expenseType = '', user = '', type = '', narration = '', date = '' } = {}) => {
    //     try {
    //         const backendUrl = process.env.REACT_APP_BACKEND_URL;
    //         const userInfo = JSON.parse(localStorage.getItem('user-info'));
    //         const origin = localStorage.getItem('user-origin');
    //         const token = userInfo?.token;

    //         // Construct params dynamically
    //         let params = new URLSearchParams();
    //         params.append('page', page);

    //         // Apply search query globally
    //         if (search) params.append('search', search);
    //         if (project === 'no-project') {
    //             // Special case for filtering expenses with no project
    //             params.append('no_project', 'true');
    //         } else if (project) {
    //             params.append('project_id', project);
    //         }
    //         if (expenseType) params.append('expense_type_id', expenseType);
    //         if (user) params.append('user_id', user);
    //         if (dateRange?.from) params.append('from_date', dateRange.from);
    //         if (dateRange?.to) params.append('to_date', dateRange.to);
    //         if (type) params.append('tax_type', type);
    //         if (narration) params.append('narration', narration);

    //         const response = await axios.get(`${backendUrl}/api/expense?${params.toString()}`, {
    //             headers: {
    //                 'Authorization': `Bearer ${token}`,
    //                 'Tenant-Origin': origin,
    //             },
    //         });

    //         console.log('Expense Response:', response.data);
    //         const expenseData = response.data.data?.data || [];



    //         // Extract pagination info correctly
    //         const totalPages = response.data.data?.last_page || 1;
    //         const currentPage = response.data.data?.current_page || 1;

    //         setExpenses(expenseData);
    //         setPageCount(totalPages);
    //         setCurrentPage(currentPage);
    //     } catch (error) {
    //         console.error('Error fetching expenses:', error);
    //     }
    // };



    const fetchExpenseTypes = async (page = 1) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            const response = await axios.get(`${backendUrl}/api/expense-type`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,


            });
            const sortedExpenseTypes = (response.data.expense || []).sort((a, b) => (a.name || '').localeCompare(b.name || ''));
            setExpenseTypes(sortedExpenseTypes);



        } catch (error) {
            console.error('Error fetching expenseTypes:', error);
        }
    };
    const fetchUsers = async (page = 1) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            const response = await axios.get(`${backendUrl}/api/users`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,

            });
            const sortedUsers = (response.data.users || []).sort((a, b) => (a.name || '').localeCompare(b.name || ''));
            setUsers(sortedUsers);



        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
    const [projects, setProjects] = useState([]);

    const fetchProjects = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/projects`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            const sortedProjects = (response.data.Data || []).sort((a, b) => (a.name || '').localeCompare(b.name || ''));
            setProjects(sortedProjects);
        } catch (error) {
            console.error('Error fetching projects:', error);
        }
    };

    const fetchVendors = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/expense-report/filter-options`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });
            setVendors(response.data.vendors || []);
        } catch (error) {
            console.error('Error fetching vendors:', error);
        }
    };

    useEffect(() => {
        fetchProjects();
        fetchExpenseTypes();
        fetchUsers();
        fetchVendors();
    }, []);

    const totalExpenseAmount = expenses.reduce((sum, item) => sum + Number(item.amount), 0);

    // const addExpense = async (newExpense) => {
    //     try {
    //         const backendUrl = process.env.REACT_APP_BACKEND_URL;

    //         const userInfo = JSON.parse(localStorage.getItem('user-info'));
    //         const token = userInfo?.token;

    //         const response = await axios.post(`${backendUrl}/api/expense`, newExpense, {
    //             headers: {
    //                 'Authorization': `Bearer ${token}`,
    //             },
    //         });

    //         const createdExpense = response.data?.data;


    //         if (createdExpense) {
    //             setExpenses((prevExpense) => Array.isArray(prevExpense) ? [...prevExpense, createdExpense] : [createdExpense]);
    //         } else {
    //             console.error('Creation failed, no data returned.');
    //         }

    //         handleCloseModal();
    //     } catch (error) {
    //         if (error.response?.data?.errors) {
    //             return error.response.data.errors;
    //         } else {
    //             console.error('Error adding expense:', error);
    //         }
    //     }
    // };


    const fetchAllProjectExpenses = async (projectId) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/expense?project_id=${projectId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            return response.data?.data || [];
        } catch (error) {
            console.error("❌ Error fetching full expenses list:", error);
            return [];
        }
    };


    const addExpense = async (newExpenseFormData) => {
        console.log("🚀 newExpense before submission (FormData):", newExpenseFormData);

        const newExpense = Object.fromEntries(newExpenseFormData.entries());
        console.log("📜 Converted newExpense Object:", newExpense);

        const selectedProjectId = newExpense.project_id ? String(newExpense.project_id).trim() : "";
        const isExternal = newExpense.type?.toLowerCase() === 'external';
        // if (!selectedProjectId && !isExternal) {
        //     Swal.fire({ icon: "error", text: "Please select a project before adding expenses." });
        //     return;
        // }

        const selectedProject = projects.find(p => String(p.id).trim() === selectedProjectId);
        if (!isExternal) {

            // if (!selectedProject) {
            //     Swal.fire({ icon: "error", text: `Invalid project selection (${selectedProjectId}).` });
            //     return;
            // }


            // ✅ Fetch full expenses list for the selected project
            const fullProjectExpenses = await fetchAllProjectExpenses(selectedProjectId);
            console.log("📊 Full Expenses for Selected Project:", fullProjectExpenses);

            // const expenditureLimit = parseFloat(selectedProject.expenditure_amount || 0);
            const newExpenseAmount = parseFloat(newExpense.amount || 0);

            // ✅ Calculate total including new expense
            const updatedTotalExpenseAmount = [...fullProjectExpenses, newExpense]
                .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);

            // console.log("💰 Expenditure Limit:", expenditureLimit);
            console.log("✅ Corrected Total with New Expense:", updatedTotalExpenseAmount);

            // if (updatedTotalExpenseAmount > expenditureLimit) {
            //     Swal.fire({
            //         toast: true,
            //         position: 'top-end',
            //         icon: 'warning',
            //         text: `Budget Exceeded! Adding this expense will exceed  ${expenditureLimit}.`,
            //         showConfirmButton: false,
            //         timer: 4000,
            //         timerProgressBar: false
            //     });
            //     return;
            // }
        }

        // ✅ Proceed with adding the expense
        try {
            console.log("📡 Sending API Request...");
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.post(`${backendUrl}/api/expense`, newExpense, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                    'Tenant-Origin': origin,
                },
            });

            const createdExpense = response.data?.data;
            if (createdExpense) {
                console.log("✅ Expense Created:", createdExpense);
                setExpenses((prevExpense) =>
                    Array.isArray(prevExpense) ? [...prevExpense, createdExpense] : [createdExpense]
                );
                // if (createdExpense.user_id) {
                // }

            }

            handleCloseModal();
            showToast1("Expense Added Successfully.");

        } catch (error) {
            console.error(error);
            throw error;
            console.error("❌ Error adding expense:", error);
        }
    };



    const editExpense = async (expenseId, updatedData) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            const webzashBaseUrl = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration';
            const APIkey = process.env.REACT_APP_API_KEY || '';

            const config = {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data', // Ensure file uploads work
                    'Tenant-Origin': origin,
                },
            };

            const response = await axios.post(`${backendUrl}/api/expense/${expenseId}?_method=PUT`, updatedData, config);

            console.log('Updated Expense Response:', response.data);

            const updatedExpense = response.data?.data;
            if (!updatedExpense) {
                console.error('Update failed, no data returned.');
                return;
            }


            if (updatedExpense) {
                setExpenses((prevExpenses) =>
                    prevExpenses.map((expense) =>
                        expense.id === expenseId ? { ...expense, ...updatedExpense } : expense
                    )
                );
            } else {
                console.error('Update failed, no data returned.');
            }

            handleCloseModal();
            showToast1("Expense Updated Successfully.");

        } catch (error) {
            console.error(error);
            throw error;
        }
    };



    const deleteExpense = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const backendUrl = process.env.REACT_APP_BACKEND_URL;

                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');
                    const token = userInfo?.token;
                    const webzashBaseUrl = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration';
                    const APIkey = process.env.REACT_APP_API_KEY || '';
                    const expenseRes = await axios.get(`${backendUrl}/api/expense/${id}`, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                    });
                    const journalId = expenseRes?.data?.journal_id;
                    const isPaid = expenseRes?.data?.is_paid === '1' || expenseRes?.data?.is_paid === true;

                    // Check if expense is already paid
                    if (isPaid) {
                        // Show warning toast
                        showToast(
                            "This expense has already been paid. Please delete the payment transaction first before deleting the expense.",
                            "warning"
                        );
                        return; // Stop the deletion process
                    }

                    await axios.delete(` ${backendUrl}/api/expense/${id}`, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                    });

                    setExpenses(expenses.filter(expense => expense.id !== id));
                    Swal.fire(
                        "Deleted!",
                        "The expense has been deleted.",
                        "success"
                    );
                } catch (error) {
                    console.error('Error deleting expense:', error);
                    Swal.fire(
                        "Error!",
                        "Failed to delete expense. Please try again.",
                        "error"
                    );
                }
            }
        });
    };
    const [isEditMode, setIsEditMode] = useState(false);


    // const handleShowModal = (expenseId = null) => {
    //     console.log("handleShowModal called with expenseId:", expenseId);

    //     if (expenseId !== null) {
    //         const expenseToEdit = expenses.find(expense => expense.id === expenseId);
    //         setSelectedExpenseData(expenseToEdit || null);
    //         setSelectedExpenseId(expenseId);
    //     } else {
    //         setSelectedExpenseData(null);
    //         setSelectedExpenseId(null);
    //         setErrors({});
    //     }

    //     setShowModal(true);
    // };

    // parent
    const handleShowModal = (expenseId = null, mode = "view") => {
        console.log("handleShowModal called with expenseId:", expenseId, "mode:", mode);

        if (expenseId !== null) {
            const expenseToEdit = expenses.find(expense => expense.id === expenseId);
            setSelectedExpenseData(expenseToEdit || null);
            setSelectedExpenseId(expenseId);
        } else {
            setSelectedExpenseData(null);
            setSelectedExpenseId(null);
            setErrors({});
        }

        // 👇 set mode here
        setIsEditMode(mode === "edit");

        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedExpenseId(null);
        setSelectedExpenseData(null);
        setErrors({});
        setIsEditMode(false);
    };

    // const handlePageClick = ({ selected }) => {
    //     const newPage = selected + 1;
    //     setCurrentPage(newPage);
    //     fetchExpenses({
    //         page: newPage,
    //         search: searchQuery,
    //         project: projectFilter,
    //         expenseType: expenseTypeFilter,
    //         user: userFilter
    //     });
    // };

    const handleFilterChange = (filterType, value) => {
        setCurrentPage(1);

        if (filterType === 'project') setProjectFilter(value);
        if (filterType === 'expenseType') setExpenseTypeFilter(value);
        if (filterType === 'user') setUserFilter(value);
        if (filterType === 'type') setTypeFilter(value);
        if (filterType === 'paymentStatus') setStatusFilter(value);
        if (filterType === 'vendor') setVendorFilter(value);


        setFilterDropdown(null); // Close dropdown after selection
    };





    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setDateRange((prev) => ({ ...prev, [name]: value }));
    };
    const applyDateFilter = () => {
        setDateFilterDropdown(false); // Close the dropdown after applying
        fetchExpenses();
    };
    const clearDateFilter = () => {
        setDateRange({ from: "", to: "" }); // Reset date inputs
    };
    // const backendUrl = 'http://localhost/webzash/api';

    const handleImport = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const formData = new FormData();
            formData.append('file', file);

            const response = await axios.post(
                `${backendUrl}/api/expense/import`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                        'Tenant-Origin': origin,
                    },
                }
            );

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: response.data.message || ` Imported successfully!`,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
            if (response.data.warnings && response.data.warnings.length > 0) {
                response.data.warnings.forEach((warning, index) => {
                    setTimeout(() => {
                        Swal.fire({
                            toast: true,
                            position: 'top-end',
                            icon: 'warning',
                            title: warning,
                            timer: 4000,
                            timerProgressBar: true,
                            showConfirmButton: false,
                            didOpen: () => {
                                const container = Swal.getContainer();
                                container.style.top = '50px';
                            },
                        });
                    }, index * 500); // staggered display
                });
            }

            // Refresh the list after import
            setTimeout(() => window.location.reload(), 1500);

            // Clear the file input
            event.target.value = '';

        } catch (error) {
            console.error('Import error:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: error.response?.data?.errors || error.response?.errors || `Failed to import instance information`,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
            event.target.value = "";

        } finally {
        }
    };
    const formatUSCurrency = (amount) => {
        if (!amount && amount !== 0) return '0.00';
        return parseFloat(amount).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };


    // Export Functions
    const handleExport = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const params = new URLSearchParams();
            if (searchQuery) params.append('search', searchQuery);
            if (projectFilter === 'no-project') {
                params.append('no_project', 'true');
            } else if (projectFilter) {
                params.append('project_id', projectFilter);
            }
            if (expenseTypeFilter) params.append('expense_type_id', expenseTypeFilter);
            if (userFilter) params.append('user_id', userFilter);
            if (startDateFilter) params.append('from_date', startDateFilter);
            if (endDateFilter) params.append('to_date', endDateFilter);
            if (typeFilter) params.append('type', typeFilter);
            if (Array.isArray(sourceFilter) && sourceFilter.length > 0) {
                params.append('source', sourceFilter.join(','));
            } else if (sourceFilter && sourceFilter !== 'all' && !Array.isArray(sourceFilter)) {
                params.append('source', sourceFilter);
            }
            if (attachmentFilter === 'without') {
                params.append('attachment_null', 'true');
            } else if (attachmentFilter === 'with') {
                params.append('attachment_not_null', 'true');
            }
            if (summaryFilter && summaryFilter !== 'all') {
                params.append('tax_type', summaryFilter);
            }

            const response = await axios.get(
                `${backendUrl}/api/expense/export?${params.toString()}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                    responseType: 'blob', // Important for file download
                }
            );

            // Create blob link and download
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            // Get filename from response headers or use default
            const contentDisposition = response.headers['content-disposition'];
            let filename = `Expenses_${new Date().toISOString().split('T')[0]}.xlsx`;

            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
                if (filenameMatch.length === 2) {
                    filename = filenameMatch[1];
                }
            }

            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: `Exported successfully!`,
                timer: 2000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });

        } catch (error) {
            console.error('Export error:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: `Failed to export`,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
        } finally {
        }
    };
    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    {/* Page Title */}

                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Expenses</h4>
                                <div className="page-title-right">

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title mb-3">
                                        <FaFilter className="me-2" />
                                        Filters
                                    </h5>
                                    <div className="row g-2">
                                        <div className="col-md-2">
                                            <label className="form-label font-size-11 mb-1">Date Range</label>
                                            <select
                                                className="form-select font-size-11"
                                                value={dateRangeFilter}
                                                onChange={(e) => handleDateRangeChange(e.target.value)}
                                            >
                                                <option value="yearly">Yearly</option>
                                                <option value="custom">Custom Range</option>
                                            </select>
                                        </div>

                                        {dateRangeFilter === 'yearly' && (
                                            <>
                                                <div className="col-md-2">
                                                    <label className="form-label font-size-11 mb-1">Start Date</label>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            views={["year", "month", "day"]}
                                                            openTo="year"
                                                            format="DD-MM-YYYY"
                                                            value={startDateFilter ? dayjs(startDateFilter) : null}
                                                            onChange={(newValue) => {
                                                                if (newValue) {
                                                                    if (!startDateFilter || dayjs(startDateFilter).year() !== newValue.year()) {
                                                                        const start = newValue.startOf('year');
                                                                        setStartDateFilter(start.format('YYYY-MM-DD'));
                                                                        setEndDateFilter(newValue.endOf('year').format('YYYY-MM-DD'));
                                                                        setSelectedEndYear(newValue);
                                                                    } else {
                                                                        setStartDateFilter(newValue.format('YYYY-MM-DD'));
                                                                        if (endDateFilter && dayjs(newValue.format('YYYY-MM-DD')).isAfter(dayjs(endDateFilter, "YYYY-MM-DD"), 'day')) {
                                                                            setEndDateFilter(dayjs(newValue.format('YYYY-MM-DD')).endOf('month').format('YYYY-MM-DD'));
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                            slotProps={{
                                                                textField: {
                                                                    size: "small",
                                                                    fullWidth: true,
                                                                    variant: "outlined",
                                                                    inputProps: { style: { fontSize: '11px', padding: '6px 12px' } }
                                                                },
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                </div>
                                                <div className="col-md-2">
                                                    <label className="form-label font-size-11 mb-1">End Date</label>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            views={["year", "month", "day"]}
                                                            openTo="year"
                                                            format="DD-MM-YYYY"
                                                            value={endDateFilter ? dayjs(endDateFilter) : null}
                                                            onChange={(newValue) => {
                                                                if (newValue) {
                                                                    setSelectedEndYear(newValue);
                                                                    if (!endDateFilter || dayjs(endDateFilter).year() !== newValue.year()) {
                                                                        setEndDateFilter(newValue.endOf('year').format('YYYY-MM-DD'));
                                                                    } else {
                                                                        const dateStr = newValue.format('YYYY-MM-DD');
                                                                        if (startDateFilter && dayjs(dateStr).isBefore(dayjs(startDateFilter, "YYYY-MM-DD"), 'day')) {
                                                                            setEndDateFilter(dayjs(startDateFilter).endOf('month').format('YYYY-MM-DD'));
                                                                        } else {
                                                                            setEndDateFilter(dateStr);
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                            slotProps={{
                                                                textField: {
                                                                    size: "small",
                                                                    fullWidth: true,
                                                                    variant: "outlined",
                                                                    inputProps: { style: { fontSize: '11px', padding: '6px 10px' } }
                                                                },
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                </div>
                                            </>
                                        )}

                                        {dateRangeFilter === 'custom' && (
                                            <>
                                                <div className="col-md-2">
                                                    <label className="form-label font-size-11 mb-1">Start Date</label>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            views={["year", "month", "day"]}
                                                            format="DD-MM-YYYY"
                                                            value={startDateFilter ? dayjs(startDateFilter) : null}
                                                            onChange={(newValue) => {
                                                                const dateStr = newValue ? newValue.format("YYYY-MM-DD") : "";
                                                                setStartDateFilter(dateStr);
                                                                if (newValue && endDateFilter && newValue.isAfter(dayjs(endDateFilter, "YYYY-MM-DD"), 'day')) {
                                                                    setEndDateFilter(newValue.endOf('month').format('YYYY-MM-DD'));
                                                                }
                                                            }}
                                                            slotProps={{
                                                                textField: {
                                                                    size: "small",
                                                                    fullWidth: true,
                                                                    variant: "outlined",
                                                                    inputProps: { style: { fontSize: '11px', padding: '6px 10px' } }
                                                                },
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                </div>
                                                <div className="col-md-2">
                                                    <label className="form-label font-size-11 mb-1">End Date</label>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            views={["year", "month", "day"]}
                                                            format="DD-MM-YYYY"
                                                            value={endDateFilter ? dayjs(endDateFilter) : null}
                                                            onChange={(newValue) => {
                                                                if (newValue && startDateFilter && newValue.isBefore(dayjs(startDateFilter, "YYYY-MM-DD"), 'day')) {
                                                                    setEndDateFilter(dayjs(startDateFilter).endOf('month').format('YYYY-MM-DD'));
                                                                } else {
                                                                    setEndDateFilter(newValue ? newValue.format("YYYY-MM-DD") : "");
                                                                }
                                                            }}
                                                            slotProps={{
                                                                textField: {
                                                                    size: "small",
                                                                    fullWidth: true,
                                                                    variant: "outlined",
                                                                    inputProps: { style: { fontSize: '11px', padding: '6px 10px' } }
                                                                },
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                </div>
                                            </>
                                        )}


                                        {/* Attachment Filter */}
                                        <div className="col-md-1">
                                            <label className="form-label font-size-11 mb-1">Attachment</label>
                                            <select
                                                className="form-select font-size-11"
                                                value={attachmentFilter}
                                                onChange={(e) => setAttachmentFilter(e.target.value)}
                                            >
                                                <option value="all" className='font-size-11'>All Attachments</option>
                                                <option value="with" className='font-size-11'>With Attachment</option>
                                                <option value="without" className='font-size-11'>Without Attachment</option>
                                            </select>
                                        </div>

                                        {/* Payment Status Filter */}
                                        <div className="col-md-1">
                                            <label className="form-label font-size-11 mb-1">Payment Status</label>
                                            <select
                                                className="form-select font-size-11"
                                                value={statusFilter}
                                                onChange={(e) => setStatusFilter(e.target.value)}
                                            >
                                                <option value="all" className='font-size-11'>All</option>
                                                <option value="Paid" className='font-size-11'>Paid</option>
                                                <option value="Unpaid" className='font-size-11'>Unpaid</option>
                                                <option value="Partial" className='font-size-11'>Partial</option>
                                            </select>
                                        </div>

                                        {/* Source Filter */}
                                        <div className="col-md-2">
                                            <label className="form-label font-size-11 mb-1">Expense Type</label>
                                            <Select
                                                isMulti
                                                options={[
                                                    { value: 'direct', label: 'Direct' },
                                                    { value: 'pettycash', label: 'Petty Cash' },
                                                    { value: 'salary', label: 'Salary' }
                                                ]}
                                                value={[
                                                    { value: 'direct', label: 'Direct' },
                                                    { value: 'pettycash', label: 'Petty Cash' },
                                                    { value: 'salary', label: 'Salary' }
                                                ].filter(option => sourceFilter.includes(option.value))}
                                                onChange={(selectedOptions) => {
                                                    setSourceFilter(selectedOptions ? selectedOptions.map(option => option.value) : []);
                                                }}
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        minHeight: '31px',
                                                        fontSize: '11px',
                                                        borderColor: '#ced4da',
                                                        boxShadow: 'none',
                                                        '&:hover': { borderColor: '#b3b3b3' }
                                                    }),
                                                    menu: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                        fontSize: '11px'
                                                    }),
                                                    valueContainer: (base) => ({
                                                        ...base,
                                                        padding: '0px 8px',
                                                    }),
                                                    indicatorsContainer: (base) => ({
                                                        ...base,
                                                        height: '31px'
                                                    }),
                                                    multiValue: (base) => ({
                                                        ...base,
                                                        backgroundColor: '#e9ecef',
                                                        margin: '1px'
                                                    }),
                                                    multiValueLabel: (base) => ({
                                                        ...base,
                                                        fontSize: '10px',
                                                        padding: '1px 4px',
                                                        color: '#495057'
                                                    })
                                                }}
                                                placeholder="Select Type..."
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                            />
                                        </div>

                                        {/* Tax Type Filter */}
                                        <div className="col-md-1">
                                            <label className="form-label font-size-11 mb-1">Tax Type</label>
                                            <select
                                                className="form-select"
                                                value={summaryFilter}
                                                onChange={(e) => setSummaryFilter(e.target.value)}
                                            >
                                                <option value="all" className='font-size-11'>All Tax Types</option>
                                                <option value="taxable" className='font-size-11'>Taxable</option>
                                                <option value="non-taxable" className='font-size-11'>Non-Taxable</option>
                                            </select>
                                        </div>

                                     
                                      

                                        {/* User Filter */}
                                        <div className="col-md-1 mt-2">
                                            <label className="form-label font-size-11 mb-1">User</label>
                                            <select
                                                className="form-select"
                                                value={userFilter}
                                                onChange={(e) => handleFilterChange('user', e.target.value)}
                                            >
                                                <option value="">All Users</option>
                                                {users.map((u) => (
                                                    <option key={u.id} value={u.id}>{u.name}</option>
                                                ))}
                                            </select>
                                        </div>

                                        {/* Vendor Filter */}
                                        <div className="col-md-1 mt-2">
                                            <label className="form-label font-size-11 mb-1">Vendor/Client</label>
                                            <select
                                                className="form-select"
                                                value={vendorFilter}
                                                onChange={(e) => handleFilterChange('vendor', e.target.value)}
                                            >
                                                <option value="">All Vendors</option>
                                                {vendors.map((v) => (
                                                    <option key={v.id} value={v.id}>{v.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="row g-2 mt-2">
                                        <div className="col-md-9">
                                            <InputGroup size="sm">
                                                <InputGroup.Text className="bg-light border-end-0">
                                                    <FiSearch className="text-muted" />
                                                </InputGroup.Text>
                                                <Form.Control
                                                    className="bg-light border-start-0"
                                                    placeholder="Search expenses by narration or reference..."
                                                    value={searchQuery}
                                                    onChange={handleSearchChange}
                                                />
                                            </InputGroup>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="d-flex gap-1">
                                                <button
                                                    className="btn btn-primary btn-sm font-size-11 flex-fill"
                                                    onClick={applyFilters}
                                                >
                                                    <FaFilter className="me-1" />
                                                    Apply
                                                </button>

                                                <button
                                                    className="btn btn-secondary btn-sm font-size-11 flex-fill"
                                                    onClick={clearAllFilters}
                                                >
                                                    Clear
                                                </button>
                                            </div>
                                        </div>


                                    </div>

                                    {(startDateFilter || endDateFilter || projectFilter || expenseTypeFilter || userFilter || searchQuery || statusFilter !== 'all' || attachmentFilter !== 'all' || summaryFilter !== 'all') && (
                                        <div className="mt-2">
                                            <small className="text-muted">Active Filters:</small>
                                            <div className="d-flex flex-wrap gap-1 mt-1">
                                                {startDateFilter && endDateFilter && dayjs(startDateFilter).isSame(dayjs(endDateFilter).startOf('year'), 'day') && dayjs(endDateFilter).isSame(dayjs(startDateFilter).endOf('year'), 'day') ? (
                                                    <span className="badge bg-info">
                                                        Period: {dayjs(startDateFilter).format('MMM YYYY')} – {dayjs(endDateFilter).format('MMM YYYY')}
                                                    </span>
                                                ) : (
                                                    <>
                                                        {startDateFilter && (
                                                            <span className="badge bg-info">
                                                                From: {dayjs(startDateFilter).format('DD-MM-YYYY')}
                                                            </span>
                                                        )}
                                                        {endDateFilter && (
                                                            <span className="badge bg-info">
                                                                To: {dayjs(endDateFilter).format('DD-MM-YYYY')}
                                                            </span>
                                                        )}
                                                    </>
                                                )}
                                                {projectFilter && (
                                                    <span className="badge bg-warning text-dark">
                                                        Project: {projectFilter === 'no-project' ? 'No Project' : projects.find(p => p.id == projectFilter)?.name}
                                                    </span>
                                                )}
                                                {expenseTypeFilter && (
                                                    <span className="badge bg-success">
                                                        Type: {expenseTypes.find(t => t.id == expenseTypeFilter)?.name}
                                                    </span>
                                                )}
                                                {userFilter && (
                                                    <span className="badge bg-secondary">
                                                        User: {users.find(u => u.id == userFilter)?.name}
                                                    </span>
                                                )}
                                                {searchQuery && (
                                                    <span className="badge bg-primary">
                                                        Search: "{searchQuery}"
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Summary Box */}
                    {showSummaryBox && (
                        <div className="row mb-3">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-body p-3">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <h5 className="card-title mb-0">Expense Summary</h5>
                                            <div>
                                                <span className="badge bg-info me-2">
                                                    Total: {summaryData.total_count} expenses
                                                </span>
                                                <button
                                                    className="btn btn-sm btn-outline-secondary"
                                                    onClick={() => setShowSummaryBox(false)}
                                                >
                                                    Hide
                                                </button>
                                            </div>
                                        </div>

                                        <div className="row">
                                            {/* Total Amount */}
                                            <div className="col-md-2">
                                                <div className="card bg-light border-0">
                                                    <div className="card-body p-2">
                                                        <small className="text-muted d-block">
                                                            {isSalarySearch ? 'Amount (Excl. WPS & VAT)' : 'Total Amount (excl. VAT)'}
                                                        </small>
                                                        <h5 className="mb-0 text-primary">
                                                            {formatCurrency(summaryData.total_amount)}
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Standard VAT Amount */}
                                            {isStandardSearch && (
                                                <div className="col-md-2">
                                                    <div className="card bg-light border-0">
                                                        <div className="card-body p-2">
                                                            <small className="text-muted d-block">Total VAT (5%)</small>
                                                            <h5 className="mb-0 text-success">
                                                                {formatCurrency(summaryData.total_vat)}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {/* WPS VAT Summary (Salary Only) */}
                                            {isSalarySearch && (
                                                <div className="col-md-2">
                                                    <div className="card bg-light border-0">
                                                        <div className="card-body p-2">
                                                            <small className="text-muted d-block">Total WPS VAT</small>
                                                            <h5 className="mb-0 text-success">
                                                                {formatCurrency(summaryData.total_wps_vat)}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {/* WPS Charge Summary (Salary Only) */}
                                            {isSalarySearch && (
                                                <div className="col-md-2">
                                                    <div className="card bg-light border-0">
                                                        <div className="card-body p-2">
                                                            <small className="text-muted d-block">Total WPS Charge</small>
                                                            <h5 className="mb-0 text-info">
                                                                {formatCurrency(summaryData.total_wps_charge)}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Total Adjustment */}
                                            <div className="col-md-2">
                                                <div className="card bg-light border-0">
                                                    <div className="card-body p-2">
                                                        <small className="text-muted d-block">Total Adjustment</small>
                                                        <h5 className="mb-0 text-warning">
                                                            {formatCurrency(summaryData.total_adjustment)}
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Grand Total */}
                                            <div className="col-md-2">
                                                <div className="card bg-light text-white">
                                                    <div className="card-body p-2">
                                                        <small className="d-block text-muted">Grand Total</small>
                                                        <h5 className="mb-0 text-success">
                                                            {formatCurrency(summaryData.grand_total)}
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Total Unpaid */}
                                            <div className="col-md-2">
                                                <div className="card bg-light border-0">
                                                    <div className="card-body p-2">
                                                        <small className="text-muted d-block">Total Unpaid</small>
                                                        <h5 className="mb-0 text-dark">
                                                            {formatCurrency(summaryData.total_unpaid || 0)}
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Total Paid */}
                                            <div className="col-md-2">
                                                <div className="card bg-light border-0">
                                                    <div className="card-body p-2">
                                                        <small className="text-muted d-block">Total Paid</small>
                                                        <h5 className="mb-0 text-success">
                                                            {formatCurrency(summaryData.total_paid || 0)}
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Total Balance */}
                                            <div className="col-md-2">
                                                <div className="card bg-light border-0">
                                                    <div className="card-body p-2">
                                                        <small className="text-muted d-block">Total Balance</small>
                                                        <h5 className="mb-0 text-danger">
                                                            {formatCurrency(summaryData.total_balance || 0)}
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Tax Breakdown */}
                                            {/* <div className="col-md-2">
                                                <div className="card bg-light border-0">
                                                    <div className="card-body p-2">
                                                        <div className="d-flex justify-content-between">
                                                            <small className="text-muted">
                                                                {isSalarySearch ? 'Taxable (WPS):' : 'Taxable:'}
                                                            </small>
                                                            <small className="text-success">{summaryData.taxable_count}</small>
                                                        </div>
                                                        <div className="d-flex justify-content-between">
                                                            <small className="text-muted">
                                                                {isSalarySearch ? 'Non-Taxable (WPS):' : 'Non-Taxable:'}
                                                            </small>
                                                            <small className="text-info">{summaryData.non_taxable_count}</small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> */}
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {/* If summary is hidden, show toggle button */}
                    {!showSummaryBox && (
                        <div className="row mb-3">
                            <div className="col-12">
                                <button
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={() => setShowSummaryBox(true)}
                                >
                                    <FaFilter className="me-1" />
                                    Show Summary & Filters
                                </button>
                            </div>
                        </div>
                    )}




                    {/* Instance Table */}
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    {/* <div className="d-flex justify-content-end mb-3"> */}
                                    <div className="d-flex justify-content-end mb-3">
                                        <div className="d-flex">
                                            {/* Removed search box from here */}
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            {/* Export Button */}
                                            <button
                                                type="button"
                                                className="btn btn-light border"
                                                onClick={handleExport}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Export"
                                            >
                                                <i className="mdi mdi-file-excel text-success"></i>
                                            </button>

                                            {/* Import Button */}

                                            <WithCreatePermission>
                                                <button
                                                    type="button"
                                                    className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"

                                                    onClick={() => handleShowModal(null, "edit")}
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title="Add Expense"
                                                >
                                                    <i className="mdi mdi-plus" style={{ fontSize: "16px" }}></i>
                                                </button>
                                            </WithCreatePermission>
                                        </div>

                                    </div>


                                    <div>
                                        <table className="table align-middle table-nowrap table-check table-list">

                                            <thead className="table-sales-gradient">
                                                <tr>
                                                    <th style={{ width: '20px' }} className="align-middle">
                                                        <div className="form-check font-size-16">
                                                            <input className="form-check-input" type="checkbox" id="checkAll" />
                                                            <label className="form-check-label" htmlFor="checkAll"></label>
                                                        </div>
                                                    </th>
                                                    <th style={{ width: '50px' }} className="align-middle text-center">#</th>
                                                    <th className='align-middle'>Description</th>

                                                    <th className="align-middle">Date <div className="dropdown d-inline-block">
                                                        <FaFilter
                                                            className="ms-2 cursor-pointer filter-color"
                                                            onClick={() => setDateFilterDropdown(!dateFilterDropdown)}
                                                        />
                                                        {dateFilterDropdown && (
                                                            <div className="dropdown-menu show p-3" style={{ minWidth: '250px' }}>
                                                                <label className="form-label">From</label>
                                                                <input type="date" className="form-control mb-2" name="from" value={dateRange.from} onChange={handleDateChange} />

                                                                <label className="form-label">To</label>
                                                                <input type="date" className="form-control mb-2" name="to" value={dateRange.to} onChange={handleDateChange} />

                                                                <div className="text-end mt-3">
                                                                    <button className="btn btn-primary btn-sm d-inline-block w-auto me-2" onClick={applyDateFilter}>
                                                                        Apply
                                                                    </button>
                                                                    <button className="btn btn-secondary btn-sm d-inline-block w-auto" onClick={clearDateFilter}>
                                                                        Clear
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div></th>
                                                    <th className="align-middle">Expense Type
                                                        <div className="dropdown d-inline-block">
                                                            <FaFilter
                                                                className="ms-2 cursor-pointer filter-color"
                                                                onClick={() => setFilterDropdown(filterDropdown === 'expenseType' ? null : 'expenseType')}
                                                            />
                                                            {filterDropdown === 'expenseType' && (
                                                                <ul className="dropdown-menu show">
                                                                    <li><button className="dropdown-item" onClick={() => handleFilterChange('expenseType', '')}>All</button></li>
                                                                    {expenseTypes.map((type) => (
                                                                        <li key={type.id}>
                                                                            <button className="dropdown-item" onClick={() => handleFilterChange('expenseType', type.id)}>
                                                                                {type.name}
                                                                            </button>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            )}
                                                        </div>
                                                    </th>
                                                    <th className="align-middle">Client/Supplier
                                                         <div className="dropdown d-inline-block">
                                                             <FaFilter
                                                                 className="ms-2 cursor-pointer filter-color"
                                                                 onClick={() => setFilterDropdown(filterDropdown === 'vendor' ? null : 'vendor')}
                                                             />
                                                             {filterDropdown === 'vendor' && (
                                                                 <ul className="dropdown-menu show">
                                                                     <li><button className="dropdown-item" onClick={() => handleFilterChange('vendor', '')}>All</button></li>
                                                                     {vendors.map((v) => (
                                                                         <li key={v.id}>
                                                                             <button className="dropdown-item" onClick={() => handleFilterChange('vendor', v.id)}>
                                                                                 {v.name}
                                                                             </button>
                                                                         </li>
                                                                     ))}
                                                                 </ul>
                                                             )}
                                                         </div>
                                                     </th>

                                                    <th className="align-middle">Project
                                                        <div className="dropdown d-inline-block">
                                                            <FaFilter
                                                                className="ms-2 cursor-pointer filter-color"
                                                                onClick={() => setFilterDropdown(filterDropdown === 'project' ? null : 'project')}
                                                            />
                                                            {filterDropdown === 'project' && (
                                                                <ul className="dropdown-menu show ">
                                                                    <li><button className="dropdown-item" onClick={() => handleFilterChange('project', '')}>All</button></li>
                                                                    <li>
                                                                        <button
                                                                            className="dropdown-item"
                                                                            onClick={() => handleFilterChange('project', 'no-project')}
                                                                        >
                                                                            No Project
                                                                        </button>
                                                                    </li>
                                                                    {projects.map((proj) => (
                                                                        <li key={proj.id}>
                                                                            <button className="dropdown-item" onClick={() => handleFilterChange('project', proj.id)}>
                                                                                {proj.name}
                                                                            </button>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            )}
                                                        </div>
                                                    </th>


                                                    <th className="align-middle">
                                                        User
                                                        <div className="dropdown d-inline-block">
                                                            <FaFilter
                                                                className="ms-2 cursor-pointer filter-color"
                                                                onClick={() => setFilterDropdown(filterDropdown === 'user' ? null : 'user')}
                                                            />
                                                            {filterDropdown === 'user' && (
                                                                <ul className="dropdown-menu show ">
                                                                    <li><button className="dropdown-item" onClick={() => handleFilterChange('user', '')}>All</button></li>
                                                                    {users.map((usr) => (
                                                                        <li key={usr.id}>
                                                                            <button className="dropdown-item" onClick={() => handleFilterChange('user', usr.id)}>
                                                                                {usr.name}
                                                                            </button>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            )}
                                                        </div>
                                                    </th>
                                                    <th className="align-middle">Type
                                                        <div className="dropdown d-inline-block">
                                                            <FaFilter
                                                                className="ms-2 cursor-pointer filter-color"
                                                                onClick={() => setFilterDropdown(filterDropdown === 'type' ? null : 'type')}
                                                            />
                                                            {filterDropdown === 'type' && (
                                                                <ul className="dropdown-menu show">
                                                                    <li>
                                                                        <button className="dropdown-item" onClick={() => handleFilterChange('type', '')}>
                                                                            All
                                                                        </button>
                                                                    </li>
                                                                    <li>
                                                                        <button className="dropdown-item" onClick={() => handleFilterChange('type', 'taxable')}>
                                                                            Taxable
                                                                        </button>
                                                                    </li>
                                                                    <li>
                                                                        <button className="dropdown-item" onClick={() => handleFilterChange('type', 'non-taxable')}>
                                                                            Non-Taxable
                                                                        </button>
                                                                    </li>
                                                                </ul>
                                                            )}
                                                        </div>
                                                    </th>
                                                    <th className="align-middle text-end">Amount</th>
                                                    <th className="align-middle text-end" style={{ width: '80px' }}>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {expenses.length > 0 ? (
                                                    expenses.map((expense, index) => {
                                                        const isReversed = expense.reconciliation_status === 'reversed';

                                                        return (
                                                            <tr key={expense.id}>
                                                                <td>
                                                                    <div className="form-check font-size-16">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            id={`instanceCheck${index}`}
                                                                            disabled={isReversed}
                                                                        />
                                                                        <label
                                                                            className="form-check-label"
                                                                            htmlFor={`instanceCheck${index}`}
                                                                        ></label>
                                                                    </div>
                                                                </td>
                                                                <td className="text-center">
                                                                    {index + 1}

                                                                </td>
                                                                <td onClick={() => !isReversed && handleShowModal(expense.id, "view")}
                                                                    style={{ cursor: isReversed ? 'default' : 'pointer' }}
                                                                    className={isReversed ? 'text-muted text-start narration-cell' : 'text-start narration-cell'}
                                                                    title={expense.narration || ""}>
                                                                    {expense.narration || ""}
                                                                </td>
                                                                <td onClick={() => !isReversed && handleShowModal(expense.id, "view")}
                                                                    style={{ cursor: isReversed ? 'default' : 'pointer' }}
                                                                    className={isReversed ? 'text-muted' : ''}>
                                                                    {formatDate(expense.date)}
                                                                </td>

                                                                <td onClick={() => !isReversed && handleShowModal(expense.id, "view")}
                                                                    style={{ cursor: isReversed ? 'default' : 'pointer' }}
                                                                    className={isReversed ? 'text-muted narration-cell text-start' : 'text-start narration-cell'} title={expense.expense_type?.name}>
                                                                    {expense.expense_type?.name}
                                                                </td>
                                                                <td className={isReversed ? 'text-muted' : ''}>{expense?.client?.name || expense?.vendor?.name || expense.payroll_provider_name}</td>


                                                                <td className={isReversed ? 'text-muted' : ''}>{expense.project?.name}</td>
                                                                <td className={isReversed ? 'text-muted' : ''}>{expense.user?.name}</td>
                                                                <td className={isReversed ? 'text-muted' : ''}>{expense.tax_type}</td>
                                                                <td className={`${isReversed ? 'text-muted' : ''} text-end fw-bold`} style={{ 
                                                                    color: (!isReversed) ? (
                                                                        expense.payment_status === 'Paid' ? '#198754' : 
                                                                        expense.payment_status === 'Unpaid' ? '#dc3545' : 
                                                                        '#ffc107' // Orange/Yellow for Partial
                                                                    ) : 'inherit'
                                                                }}>
                                                                    {formatUSCurrency(
                                                                        expense.grand_total || (expense.tax_type === 'taxable' ? expense.total_amount : expense.amount)
                                                                    )}
                                                                    <span className="text-muted ms-1 font-size-11 fw-normal">
                                                                        ({expense.vendor_currency})
                                                                    </span>
                                                                </td>
                                                                <td className="text-end">
                                                                    <div className="dropdown">
                                                                        {isReversed ? (
                                                                            // Show disabled three dots for reversed expenses
                                                                            <i
                                                                                className="mdi mdi-dots-horizontal font-size-18 text-muted"
                                                                                style={{
                                                                                    cursor: 'not-allowed',
                                                                                    opacity: 0.5
                                                                                }}
                                                                                title="Reversed - Actions disabled"
                                                                            ></i>
                                                                        ) : (
                                                                            // Show normal dropdown for non-reversed expenses
                                                                            <>
                                                                                <i
                                                                                    className="mdi mdi-dots-horizontal font-size-18"
                                                                                    data-bs-toggle="dropdown"
                                                                                    aria-expanded="false"
                                                                                    style={{ cursor: 'pointer' }}
                                                                                ></i>
                                                                                <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                                                                    <li>
                                                                                        <WithEditPermission>
                                                                                            <button
                                                                                                className="dropdown-item"
                                                                                                onClick={() => handleShowModal(expense.id, "edit")}
                                                                                            >
                                                                                                Edit
                                                                                            </button>
                                                                                        </WithEditPermission>
                                                                                    </li>
                                                                                    <li>
                                                                                        <WithDeletePermission>
                                                                                            <button
                                                                                                className="dropdown-item"
                                                                                                onClick={() => deleteExpense(expense.id)}
                                                                                            >
                                                                                                Delete
                                                                                            </button>
                                                                                        </WithDeletePermission>
                                                                                    </li>
                                                                                </ul>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan="11">No expenses available</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>

                                        <div className="d-flex justify-content-end pagination-sm">
                                            <ReactPaginate
                                                previousLabel={'<'}
                                                nextLabel={'>'}
                                                breakLabel={'...'}
                                                pageCount={pageCount}
                                                marginPagesDisplayed={2}
                                                pageRangeDisplayed={3}
                                                onPageChange={handlePageClick}
                                                containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                                pageClassName={'page-item'}
                                                pageLinkClassName={'page-link'}
                                                previousClassName={'page-item previous'}
                                                previousLinkClassName={'page-link'}
                                                nextClassName={'page-item next'}
                                                nextLinkClassName={'page-link'}
                                                breakClassName={'page-item'}
                                                breakLinkClassName={'page-link'}
                                                activeClassName={'active'}
                                                forcePage={currentPage - 1}
                                            />
                                        </div>
                                        {/* </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ExpenseModal
                        showModal={showModal}
                        handleClose={handleCloseModal}
                        expenseId={selectedExpenseId}
                        expenseData={selectedExpenseData}
                        addExpense={addExpense}
                        editExpense={editExpense}
                        errors={errors}
                        setErrors={setErrors}
                        fetchExpenseTypes={fetchExpenseTypes}
                        expenseTypes={expenseTypes}
                        fetchUsers={fetchUsers}
                        users={users}
                        isEditMode={isEditMode}
                        setIsEditMode={setIsEditMode}
                    />
                </div>
            </div >
        </div >

    );
};
export default AllExpenseList;










